import { useState } from "react";
import { Frame, Node, Flow, Detail } from "@/components/diagrams/kit";

const ROUTES = [
  { id: "doc", q: "“What is the torque-verification step after a chuck change?”", need: "Known static procedure", path: "Retrieve approved document chunks (RAG)", tone: "neutral", why: "Procedures live in controlled documents. Cite the SOP ID and revision." },
  { id: "live", q: "“How many capper micro-stops this shift?”", need: "Current plant measurement", path: "Call deterministic plant-data tool", tone: "data", why: "Live values come from a typed connector with units, timestamps and quality flags — never from documents or model memory." },
  { id: "graph", q: "“What sits upstream of the labeler?”", need: "Asset relationship / topology", path: "Query knowledge graph", tone: "accent", why: "Plant → line → machine → tag relationships give the answer identity." },
  { id: "write", q: "“Raise the capper torque setpoint to 2.6 N·m.”", need: "Action or write request", path: "Human approval + governed action tool", tone: "danger", why: "Consequential actions stay separate, permissioned, auditable and human-approved." },
];
const PIPE = ["Build compact context pack", "Token budget: input + output + safety margin", "LLM / SLM inference", "Answer with citations, timestamps and limits"];

export default function EvidenceRouter() {
  const [sel, setSel] = useState("live");
  const [dump, setDump] = useState(false);
  const r = ROUTES.find((x) => x.id === sel);
  return (
    <Frame title="What evidence is needed?" hint="Pick a question · follow the path" testId="diagram-evidence-router">
      <div className="grid gap-3 lg:grid-cols-2">
        <div className="space-y-2">
          {ROUTES.map((x) => (
            <Node key={x.id} testId={`route-${x.id}`} tone={x.tone} active={sel === x.id} dim={sel !== x.id} onClick={() => setSel(x.id)}>
              <div className="font-mono text-[10px] uppercase text-muted-foreground">{x.need}</div>
              <div className="italic">{x.q}</div>
              <div className="mt-1 font-semibold">→ {x.path}</div>
            </Node>
          ))}
        </div>
        <div className="flex flex-col">
          {PIPE.map((p, i) => (
            <div key={p}>
              <div className={`border p-3 text-sm ${i >= 2 ? "border-trust bg-trust text-white" : i === 1 && dump ? "border-destructive bg-destructive/10" : "border-brand-action/70 bg-brand-action/15"}`}>
                {i === 1 && dump ? "Raw logs dumped — context maxed out, output reserve gone" : p}
              </div>
              {i < PIPE.length - 1 && <Flow vertical on={!(dump && i >= 1)} />}
            </div>
          ))}
          <label className="mt-3 flex items-center gap-2 text-xs">
            <input type="checkbox" data-testid="route-dump-toggle" checked={dump} onChange={(e) => setDump(e.target.checked)} className="accent-[hsl(var(--brand-primary))]" />
            Try the anti-pattern: dump raw logs / max out context
          </label>
        </div>
      </div>
      <Detail testId="route-detail"><span key={sel}><strong>{r.path}.</strong> {r.why}</span></Detail>
    </Frame>
  );
}
